import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class ReturnOrder extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <PageBanner title='Return Your Order' background='page-banner.jpg' />
        <div className='p-5'>
          <div className='row justify-content-center'>
            <div className='col-md-6'>
              <h3 className='mb-4'>Return Your Order</h3>
              <p>
                If you're not satisfied with your purchase, you can initiate a
                return by filling out the form below. Please have your order
                number ready.
              </p>
              <form>
                <div className='form-group mb-3'>
                  <label htmlFor='orderNumber'>Order Number</label>
                  <input
                    type='text'
                    className='form-control'
                    id='orderNumber'
                    placeholder='Enter your order number'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>Email Address</label>
                  <input
                    type='email'
                    className='form-control'
                    id='email'
                    placeholder='Enter your email address'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='reason'>Reason for Return</label>
                  <textarea
                    className='form-control'
                    id='reason'
                    rows='4'
                    placeholder='Please describe the reason for your return'
                  ></textarea>
                </div>
                <button
                  type='submit'
                  className='btn'
                  style={{
                    background: '#2563eb',
                    color: '#fff',
                    fontWeight: 'bold',
                    padding: '10px 30px',
                    borderRadius: '8px',
                  }}
                >
                  Submit Return Request
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ReturnOrder;
